<div *ngIf="showOfferPayEventDebugInfo">
    Event wysłany z: {{ offerPayEventDebugInfo.postMessageObject }} <br>
    Payload:
    <pre style="white-space: pre-wrap">{{ offerPayEventPayload }}</pre>
</div>

<div class="wizard" [ngClass]="{
                                    'wizard--origin-mobile': urlParamsService.isMobileOrigin,
                                    'wizard--origin-www': urlParamsService.isWwwOrigin,
                                    'wizard--notification': wizardService.isNotificationStep,
                                    'wizard--logged-user': isLoggedUserIdParam,
                                    'wizard--offer-number-btn': sendCalculationEmailService.buttonVisible,
                                    'wizard--aztec-scanner-active': stateService.aztecScannerActive,
                                    'wizard--oc-details-step': ocDetailsStep,
                                    'wizard--vehicle-model-step': wizardService.isVehicleModelStep,
                                    'wizard--offers-step': offersStep,
                                    'wizard--order-policy-step': orderPolicyStep,
                                    'wizard--diagnostic-station': wizardService.isDiagnosticStationContext,
                                    'wizard--mobile-device': isMobileDevice,
                                    'wizard--customer-agreement-scanning-mode': wizardService.customerAgreementScanningMode,
                                    'wizard--embedded-in-iframe': wizardService.isEmbeddedInIframe,
                                    'wizard--loading': loading
                                }">

    <div class="wizard__sticky">
        <div class="wizard__header">
            <app-narrow-header *ngIf="narrowHeaderVisible"></app-narrow-header>
            <app-header *ngIf="headerVisible"></app-header>
        </div>

        <div *ngIf="stickyBanner && wizardService.nextBannerVisible"
             class="wizard__next-banner">
            <app-banner></app-banner>
        </div>
    </div>

    <div *ngIf="!stickyBanner && wizardService.nextBannerVisible"
         class="wizard__next-banner">
        <app-banner></app-banner>
    </div>

    <div class="wizard__send-offer-banner">
        <app-send-offer-banner></app-send-offer-banner>
    </div>

    <div [ngClass]="{
            'main__padding-bottom': mainContainerBottomPadding,
            'main--wide': filterVisibleAndExpanded,
            'main--full-width': fullWidthMainContainer,
            'main--hidden': mainContentHidden}"
         class="main"
         [hidden]="mainContentHidden">

        <div *ngIf="wizardService.resolveElementVisibility(mainContentHeader)" class="main__header">
            <div *ngIf="wizardService.resolveElementVisibility(mainContentHeader.logo)" class="main__logo">
                <img [src]="mainContentHeader.logo.url" alt="KioskPolis" class="main__logo--img">
            </div>
            <h2 *ngIf="wizardService.resolveElementVisibility(mainContentHeader.title)" class="main__title">
                {{ mainContentHeader.title.text | translate }}
            </h2>
        </div>

        <nav *ngIf="!readonly && wizardService.resolveElementVisibility(mainContentConfig.breadcrumb)" aria-label="breadcrumb">
            <ul class="breadcrumb breadcrumb--below-header">
                <ng-template *ngTemplateOutlet="breadcrumb"></ng-template>
            </ul>

            <app-send-offer
                    *ngIf="wizardService.resolveElementVisibility(mainContentConfig.offerNumber)"
                    [ngClass]="{'send-offer-wrapper--with-button': sendCalculationEmailService.buttonVisible}"
                    [context]="offerNumberContext"
                    class="send-offer-wrapper send-offer-wrapper--main">
            </app-send-offer>
        </nav>

        <app-customer-damage-data *ngIf="noBannerCustomerClaimDataVisible"></app-customer-damage-data>

        <app-step-info
                *ngIf="wizardService.resolveElementVisibility(stepInfo)"
                [ngClass]="{'step-info-container--customer-damage-data': noBannerCustomerClaimDataVisible}"
                [showStepCounter]="showStepCounter">
        </app-step-info>

        <div *ngIf="visibleMainImage" class="travel">
            <div class="travel__left">
                <app-shortened-vehicle-info *ngIf="shortenedVehicleInfoVisible" [context]="'OFFERS_LIST'"></app-shortened-vehicle-info>
                <app-customer-damage-data *ngIf="customerClaimDataVisible"></app-customer-damage-data>
            </div>
            <div *ngIf="htmlBannerVisible" class="wizard__banner"> <!-- HTML banner -->
                <app-step-banner [currentStepKey]="wizardService.currentStepKey"></app-step-banner>
            </div>
            <div class="travel__image" *ngIf="visibleImageBanner" [class.no-image]="!wizardService.resolveElementVisibility(mainImage)"> <!-- image banner -->
                <img [src]="bannerUrl" alt="Travel" class="travel__img">
            </div>
            <div class="vehicle-data" *ngIf="vehicleDataVisible"
                 [class.travel-with-no-image]="!wizardService.resolveElementVisibility(mainImage)">
                <app-shortened-vehicle-data></app-shortened-vehicle-data>
            </div>
        </div>

        <div *ngIf="isBankier" class="travel">
            <div *ngIf="htmlBannerVisible" class="wizard__banner"> <!-- HTML banner -->
                <app-step-banner [currentStepKey]="wizardService.currentStepKey"></app-step-banner>
            </div>
        </div>

        <template #aboveButtonSectionsContainer></template>
        <router-outlet></router-outlet>

        <div *ngIf="errorsOnStep"
             [ngClass]="{'error-validation--margin-bottom': wizardService.offerSummaryVisible}"
             class="error-validation">
            {{ 'stepValidationError' | translate }}
        </div>

        <div *ngIf="!readonly" class="wizard__bottom">
            <div *ngIf="wizardService.offerSummaryVisible"
                 class="wizard__offer-summary"
                 [ngClass]="{
                    'wizard__offer-summary--static': offerSummaryStatic,
                    'wizard__offer-summary--fixed': offerSummaryFixed,
                    'wizard__offer-summary--offers-table': wizardService.isOffersStep
                    }">
                <div *ngIf="isCarOne"
                     class="wizard__offer-summary__title">
                    {{ 'OFFER_SUMMARY_SECTION.yourPrice' | translate }}
                </div>
                <app-offer-summary  [state]="wizardService.offerSummaryState"
                                    [offer]="wizardService.offerSummaryOffer"
                                    [stepKey]="wizardService.currentStepKey"
                                    [buttonDisabled]="offerSummaryButtonDisabled"
                                    (action)="onOfferSummaryAction($event)">
                </app-offer-summary>
            </div>

            <div class="wizard__buttons"
                 *ngIf="nextButtonVisible">
                <div *ngIf="showNavigateBackButtonText" class="navigate-back-btn navigate-back-btn--text"
                     (click)="navigateBack()">
                    <div class="tooltip__icon material-icons">
                        keyboard_arrow_left
                    </div>
                    <span>{{ 'back' | translate }}</span>
                </div>
                <div *ngIf="showNavigateBackButtonIcon" class="navigate-back-btn navigate-back-btn--icon"
                     (click)="navigateBack()">
                    <div class="tooltip__icon material-icons">
                        keyboard_arrow_left
                    </div>
                </div>
                <div class="wizard__next-btn">
                    <button class="btn btn--secondary btn--big"
                            id="next-btn"
                            *ngIf="wizardService.stepButtonVisible"
                            [disabled]="nextButtonDisabled"
                            [ngClass]="{
                                'btn--disabled': nextButtonDisabled,
                                'btn--narrow': narrowButton
                            }"
                            (click)="next()">
                        {{nextButtonCaption}}
                        <img *ngIf="nextButtonIconVisible"
                             src="./assets/images/icons/car-one-arrow-right.svg"
                             alt=""
                             class="wizard__next-btn__icon"
                        >
                    </button>
                </div>
                <div *ngIf="scanAztecButtonWrapperVisible"
                     class="wizard__buttons__aztec-scanner">
                    <button *ngIf="scanAztecButtonVisible"
                            (click)="wizardService.scanAztecCode()"
                            class="btn btn--secondary btn--big btn--no-outline">
                        {{ 'AZTEC_SCANNER_INFO.scanCode' | translate }}
                    </button>
                </div>
            </div>
        </div>

        <div class="wizard__sections-below-step-button">
            <div *ngIf="isKIOSKPOLIS"
                 class="wizard__calculator-ids">
                <app-send-offer [context]="offerNumberContext"
                                [buttonVisible]="false">
                </app-send-offer>
            </div>
            <template #belowButtonSectionsContainer></template>
        </div>

    </div>

    <div class="wizard__main" fxLayout="row" fxLayoutAlign="center center" *ngIf="loading">
        <div class="lds-spinner lds-spinner--center">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>
</div>

<ng-template #breadcrumb>
    <li class="breadcrumb__item" *ngFor="let step of wizardService.stepsForNavigation; let i = index"
        [ngClass]="{
                            'active': wizardService.isActiveOrPrevious(step),
                            'breadcrumb__pointer': wizardService.shouldAllowToNavigate(step)
                         }"
        (click)="wizardService.navigateToClickedStep(step)">
        {{ i + 1 }}. {{ step.additionalInfo.stepName }}
    </li>
</ng-template>

<app-ga4-events-log *ngIf="canShowGA4EventsDebugInfo" class="wizard__ga4-events-log">
</app-ga4-events-log>

<div *ngIf="canShowMockComponent" style="border: 5px dashed">
    <table>
        <tr>
            <td style="font-weight: bold">
                DevTools
            </td>
        </tr>
        <tr>
            <td>
                <mat-form-field>
                    <mat-select [(value)]="selectedCalculation" disableOptionCentering panelClass="bottom-0"
                                [placeholder]="'Wybierz przypadek testowy'">
                        <mat-option *ngFor="let calculation of calculations" [value]="calculation.value">
                            {{calculation.key}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
            <td>
                <button class="btn btn--secondary" (click)="fillStep()">
                    Uzupełnij krok
                </button>
            </td>
        </tr>

        <tr>
            <td>
                ?sessionId=<span style="font-weight: bold">{{processService.sessionId}}</span>
                <span *ngIf="stateService.selectedOffer">&offerId=<span
                        style="font-weight: bold">{{stateService.selectedOffer.id}} </span></span>
            </td>
        </tr>
        <tr>

            <td>
                <button class="btn btn--secondary" (click)="printCalculationData()">
                    Dane Kalkulacji
                </button>
                <button class="btn btn--secondary" (click)="printRegistrationData()">
                    Dane rejestracji
                </button>
                <button class="btn btn--secondary" (click)="printBusinessParamsData()">
                    Parametry biznesowe
                </button>
                <button class="btn btn--primary" (click)="clearPrintData()">
                    Wyczyść
                </button>

                <div *ngIf="printData">
                    <pre>{{printData | json}}</pre>
                </div>
            </td>
        </tr>
    </table>
</div>
